export interface Language {
    code: string
    name: string
    flag: string
}

export const LANGUAGES: Language[] = [
    { code: 'en-US', name: 'English (US)', flag: '🇺🇸' },
    { code: 'en-GB', name: 'English (UK)', flag: '🇬🇧' },
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
    { code: 'it', name: 'Italiano', flag: '🇮🇹' },
    { code: 'pt', name: 'Português (PT)', flag: '🇵🇹' },
    { code: 'pt-BR', name: 'Português (BR)', flag: '🇧🇷' },
    { code: 'nl', name: 'Nederlands', flag: '🇳🇱' },
    { code: 'sv', name: 'Svenska', flag: '🇸🇪' },
    { code: 'pl', name: 'Polski', flag: '🇵🇱' },
    { code: 'ja', name: '日本語', flag: '🇯🇵' },
    { code: 'ko', name: '한국어', flag: '🇰🇷' },
    { code: 'ar', name: 'العربية', flag: '🇸🇦' },
    { code: 'da', name: 'Dansk', flag: '🇩🇰' },
]

// Derived lookup objects for performance
export const LANGUAGE_NAMES: Record<string, string> = LANGUAGES.reduce((acc, lang) => {
    acc[lang.code] = lang.name
    // Add 'en' as alias for 'en-US' for backward compatibility
    if (lang.code === 'en-US') acc['en'] = lang.name
    if (lang.code === 'pt') acc['pt-PT'] = lang.name  // Alias
    return acc
}, {} as Record<string, string>)

export const LANGUAGE_FLAGS: Record<string, string> = LANGUAGES.reduce((acc, lang) => {
    acc[lang.code] = lang.flag
    // Add 'en' as alias for 'en-US' for backward compatibility
    if (lang.code === 'en-US') acc['en'] = lang.flag
    if (lang.code === 'pt') acc['pt-PT'] = lang.flag  // Alias
    return acc
}, {} as Record<string, string>)

export function getLanguageByCode(code: string): Language | undefined {
    return LANGUAGES.find(lang => lang.code === code)
}

export function capitalizeFirstLetter(str: string): string {
    if (!str) return str
    const firstChar = str.charAt(0)
    if (firstChar === firstChar.toUpperCase() && firstChar === firstChar.toLowerCase()) {
        return str
    }
    return firstChar.toUpperCase() + str.slice(1)
}

